export default __webpack_public_path__ + "static/media/instagram.5fe11a46.svg";